import { render } from "./Contact.vue?vue&type=template&id=d35aba22&scoped=true&bindings={}"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=d35aba22&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-d35aba22"

export default script